module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/image/logo.png")
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.titleText))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.changeLanguage
    }
  }, [_vm._v(_vm._s(_vm.languageBtnText))]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.changeTheme
    }
  }, [_vm._v(_vm._s(_vm.themeBtnText))]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.help))]), _vm._v(" "), _c('ul', _vm._l((_vm.linkList), function(list) {
    return _c('li', [_c('a', {
      attrs: {
        "href": list.href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(list.name))])])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-92426efa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 260
// module chunks = 4